import { ajaxRequest } from "../../Utils/Ajax/ajax";


export function goToStripe(button){

    const product = $(button).attr('data-price-id')

    const url = '/stripe/product/' + product

    const success = function (data){
        loadStripe(data.stripeKey, data.sessionId)
    }

    ajaxRequest(url, success, {}, button);
    
}

export function loadStripe(stripeKey, sessionId){
    window
        .Stripe(stripeKey)
        .redirectToCheckout({
            sessionId: sessionId,
        })
        .then((result) => {
            console.error('result', result);
        });
}